export default __webpack_public_path__ + "static/media/badBunny.fc4ce7d3.jpeg";